import React from 'react';
import '../../../CSS/Dashboard/sidenav.scss';
import {MdDashboard,MdNetworkWifi} from 'react-icons/md';
import {FiMessageSquare} from 'react-icons/fi';
import {FaEnvelope} from 'react-icons/fa';
import {BsBriefcaseFill} from 'react-icons/bs';
import { NavLink } from 'react-router-dom';


const Sidenav = ()=>{
    return (
        <div className="sidenav">
            <ul>
                <li >
                    <span className="">
                        <MdDashboard className="icon"/>
                    </span>
                    <span className="custom-nav-link">
                        <NavLink exact activeClassName="active-dashboard-nav" to="/dashboard">
                            DASHBOARD 
                        </NavLink>
                    </span>
                </li>
                <li>
                    <span className="">
                        <MdDashboard className="icon"/>
                    </span>
                    <span className="custom-nav-link">
                        <NavLink exact activeClassName="active-dashboard-nav" to="/dashboard/home">
                            HOME
                        </NavLink>
                    </span>
                </li>
                <li>
                    <span className="">
                        <FiMessageSquare className="icon"/>
                    </span>
                    <span className="custom-nav-link">
                        <NavLink exact activeClassName="active-dashboard-nav" to="/dashboard/about">
                            ABOUT
                        </NavLink>
                    </span>
                </li>
                <li>
                    <span className="">
                        <FaEnvelope className="icon"/>
                    </span>
                    <span className="custom-nav-link">
                        <NavLink exact activeClassName="active-dashboard-nav" to="/dashboard/contact">
                            CONTACT
                        </NavLink>
                    </span>
                </li>
                <li>
                    <span className="">
                        <BsBriefcaseFill className="icon"/>
                    </span>
                    <span className="custom-nav-link">
                        <NavLink exact activeClassName="active-dashboard-nav" to="/dashboard/portfolio">
                            PORTFOLIO
                        </NavLink>
                    </span>
                </li>
                <li>
                    <span className="">
                        <MdNetworkWifi className="icon"/></span>
                        <span className="custom-nav-link">
                        <NavLink exact activeClassName="active-dashboard-nav" to="/dashboard/social">
                            SOCIAL
                        </NavLink>
                    </span>
                </li>
            </ul>
        </div>
    );
}

export default Sidenav;